import { useMutation, useQueryClient } from '@tanstack/react-query';

import { biometricApi } from '../api/biometric.adapter';
import type {
  BiometricRange,
  BiometricRangeUpdateInput,
} from '../types/biometric.types';
import { biometricQueryKeys } from './use-biometric-ranges';

export function useBiometricUpdateMutation() {
  const qc = useQueryClient();
  return useMutation<BiometricRange, Error, BiometricRangeUpdateInput>({
    mutationFn: (input) => biometricApi.updateRange(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: biometricQueryKeys.ranges() });
    },
  });
}
